






























import {
  defineComponent,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';

import { PaginatorInfo, DEFAULT_PAGINATOR_INFO } from '@/types/paginatorInfo';

const CommonMultiCheckboxWithIcon = defineComponent({
  setup(props: any, ctx: any) {
    const selected: Ref<boolean[]> = ref(props.value);
    const selectHandler = (i: number) => {
      if (selected.value[i]) {
        selected.value[i] = false;
      } else {
        selected.value[i] = true;
      }
      ctx.emit('input', [...selected.value]);
    };
    watch(() => props.value, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        selected.value = props.value;
      }
    });

    return {
      selected,
      selectHandler,
    };
  },
  props: {
    display: {
      type: Array,
    },
    list: {
      type: Array,
    },
    icon: {
      type: Array,
    },
    value: {
      type: Array,
      default() { return [0, 0, 0, 0]; },
    },
  },
});

export default CommonMultiCheckboxWithIcon;
